module.exports = __webpack_public_path__ + "fonts/Inter-SemiBoldItalic.ac201e3.woff2";